type DashboardPageIndicatorProps = {
  activePage?: number;
  tone?: "negative" | "positive";
};

export function DashboardPageIndicator({
  activePage = 4,
  tone = "negative",
}: DashboardPageIndicatorProps) {
  const activeClass =
    tone === "positive" ? "bg-emerald-500 text-white" : "bg-red-500 text-white";

  return (
    <div className="mt-3 flex items-center gap-1.5 xl:mt-4">
      {[1, 2, 3, 4].map((page) => (
        <span
          key={page}
          className={`flex h-6 flex-1 items-center justify-center rounded-md text-[10px] font-bold xl:h-7 xl:text-[11px] ${
            page === activePage ? activeClass : "bg-zinc-100 text-zinc-400"
          }`}
        >
          {page}
        </span>
      ))}
    </div>
  );
}
